import { MemriseError } from './errors';

export type ShareResult = 'shared' | 'copied' | 'cancelled' | 'error';

declare global {
  interface Window {
    AndroidJsInterface?: {
      shareURL?: (url: string) => void;
    };
  }
}

export const shareUrl = async (urlToShare: string): Promise<ShareResult> => {
  if (!urlToShare) {
    throw new MemriseError('URL to share is required');
  }

  if (typeof window !== 'undefined' && window.AndroidJsInterface?.shareURL) {
    window.AndroidJsInterface.shareURL(urlToShare);
    return 'shared';
  }

  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ url: urlToShare });
      return 'shared';
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return 'cancelled';
      }

      if (!(
        error instanceof DOMException &&
        (error.name === 'NotAllowedError' || error.name === 'InvalidStateError')
      )) {
        throw error;
      }
    }
  }

  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    await navigator.clipboard.writeText(urlToShare);
    return 'copied';
  }

  throw new MemriseError('No sharing method available');
};
